import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";

// @material-ui core components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Arakan components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import crudsService from "services/cruds-service";

// Settings page components
import FormField from "components/FormField";
import i18n from "i18n";

import dayjs from "dayjs";
import IconPicker from "components/IconPicker";
import { Autocomplete, Chip } from "@mui/material";
import MDInput from "components/MDInput";

function Price({
  changeHandler,
  info,
  setErrors,
  errors,
  notification,
  setNotification,
  donationDefaultValues,
  setProject,
  categories,
  autoSwitchChangeHandler,
  project,
}) {
  const { t } = i18n;
  const [inputs, setInputs] = useState([
    {
      key: "",
    },
  ]);

  const handleAddInput = () => {
    setInputs([
      ...inputs,
      {
        key: "",
      },
    ]);
    createTxt([
      ...inputs,
      {
        key: "",
      },
    ]);
  };

  useEffect(() => {
    donationDefaultValues.length > 0 && setInputs(donationDefaultValues);
  }, [donationDefaultValues]);

  const createTxt = (onChangeValue) => {
    let txt = "";
    onChangeValue.forEach((element, index) => {
      txt += element.key;
      if (index !== onChangeValue.length - 1) txt += "__";
    });
    changeHandler({
      target: { name: "donation_default_values", value: txt },
    });
  };

  const handleChange = (name, index, v) => {
    let onChangeValue = [...inputs];
    onChangeValue[index][name] = v;
    setInputs(onChangeValue);
    createTxt(onChangeValue);
  };

  const handleDeleteInput = (index) => {
    const newArray = [...inputs];
    newArray.splice(index, 1);
    setInputs(newArray);
    createTxt(newArray);
  };

  const formatForInput = (date) => {
    if (!date) return "";
    return dayjs(date).format("YYYY-MM-DDTHH:mm");
  };

  const parseFromInput = (value) => {
    return value ? dayjs(value) : null;
  };

  // Handle icon change
  const handleIconChange = (iconValue) => {
    changeHandler({
      target: { name: "icon_name", value: iconValue },
    });
  };

  return (
    <Card id="basic-info" sx={{ overflow: "visible" }}>
      <MDBox p={3}>
        <MDTypography variant="h5">بيانات التكلفة</MDTypography>
      </MDBox>
      <MDBox pb={3} px={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12}>
            <FormField
              onChange={changeHandler}
              variant="outlined"
              type="number"
              label={t("cost")}
              name="cost"
              value={info.cost}
              placeholder="cost"
              error={errors.cost}
            />
          </Grid>

          {/* Icon Picker Section */}
          <Grid item xs={12}>
            <MDBox mb={2}>
              <MDTypography variant="body2" fontWeight="medium" gutterBottom>
                أيقونة المشروع
              </MDTypography>
              <IconPicker
                value={info?.icon_name || ""}
                onChange={(iconValue) => {
                  changeHandler({
                    target: { name: "icon_name", value: iconValue },
                  });
                }}
                label="اختر أيقونة للمشروع"
                error={errors?.icon_name}
                helperText={errors?.icon_name}
              />
            </MDBox>

            {/* Preview selected icon_name */}
            {info?.icon_name && (
              <MDBox mt={2} p={2} bgcolor="grey.100" borderRadius="1px">
                <MDTypography variant="body2" fontWeight="medium" gutterBottom>
                  معاينة الأيقونة:
                </MDTypography>
                <MDBox display="flex" alignItems="center" gap={2}>
                  <Icon icon={info.icon_name} width={32} height={32} />
                  <MDTypography variant="body2" color="secondary">
                    {info.icon_name}
                  </MDTypography>
                </MDBox>
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} lg={12}>
            <Autocomplete
              multiple
              options={categories}
              name="categories"
              value={info.categories || []}
              onChange={async (event, v, reason, detail) => {
                if (project.id) {
                  if (reason === "removeOption") {
                    const removedItem = project?.categories.find(
                      (orgItem) => orgItem?.id === detail.option?.id,
                    );
                    let arr = project.categories.filter(
                      (category) => category?.id !== detail.option?.id,
                    );
                    setProject({ ...project, categories: arr });
                    await crudsService.removeItemWithFilter(
                      `items/projects_categories`,
                      {
                        query: {
                          filter: {
                            categories_id: { _eq: removedItem?.id },
                            projects_id: { _eq: project?.id },
                          },
                        },
                      },
                    );
                  } else if (reason === "selectOption") {
                    let arr = project.categories;
                    arr.push(detail.option);
                    setProject({ ...project, categories: arr });
                    await crudsService.createItem(`items/projects_categories`, {
                      categories_id: detail.option?.id,
                      projects_id: project?.id,
                    });
                  }
                }
                autoSwitchChangeHandler("categories", v);
              }}
              renderOption={(props, option) => {
                const { key, ...rest } = props;
                return (
                  <li key={key} {...rest}>
                    {option.data ? option.data.name : option.name}
                  </li>
                );
              }}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => {
                  const { key, ...tagProps } = getTagProps({ index });
                  return (
                    <Chip
                      key={option.id || key}
                      {...tagProps}
                      label={option.data?.name || option.name}
                    />
                  );
                })
              }
              getOptionLabel={(option) =>
                option?.data?.name || option?.name || ""
              }
              isOptionEqualToValue={(option, item) => option?.id === item?.id}
              renderInput={(params) => (
                <MDInput
                  {...params}
                  variant="outlined"
                  label="التصنيفات"
                  error={errors.categories}
                />
              )}
            />
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

export default Price;
